module.exports = __webpack_public_path__ + "static/media/icon_dropdown.760a1c57.svg";